import React, { Component } from 'react';
import { Form, Button, Modal, Icon } from 'semantic-ui-react';
import {
    DateInput
} from 'semantic-ui-calendar-react';
import moment from 'moment';
import Select from "antd/es/select";
import './styles.scss';
import {
    Link
} from "react-router-dom";
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import functionCommon from "../../core/common/function";
import { commonService } from '../../core/services/common.service';
import { importFileAction, exportFileAction, importErOmFileAction } from "../../core/actions/commonAction";
import _ from 'lodash';
class ERModal extends Component {
    constructor(props) {
        super(props);
        let _currentYear = moment().format('YYYY');
        let _currentMonth = moment().format('MM');
        let _yearArr = [];
        for (let i = _currentYear - 9; i <= _currentYear; i++) {
            _yearArr.push(i);
        }
        let monthArr = [{name: 'Jan', value: '01'}, 
                        {name: 'Feb', value: '02'}, 
                        {name: 'Mar', value: '03'}, 
                        {name: 'Apr', value: '04'}, 
                        {name: 'May', value: '05'}, 
                        {name: 'Jun', value: '06'}, 
                        {name: 'Jul', value: '07'}, 
                        {name: 'Aug', value: '08'}, 
                        {name: 'Sep', value: '09'}, 
                        {name: 'Oct', value: '10'}, 
                        {name: 'Nov', value: '11'}, 
                        {name: 'Dec', value: '12'}];
        this.state = {
            errInputMsg: {},
            monthArr: monthArr,
            currentYear: _currentYear,
            currentMonth: _currentMonth,
            yearArr: _yearArr,
            employeeData: [],
            projectData: [],
            inputSubmit: {
                isSubmit: false,
                formError: {},
                importError: ''
            },
            importButton: true,
            importing: false,
            exportDisabled: true,
            employeeId: '',
            supervisorId: '',
            approverId: '',
            projectId: '',
            fromDate: moment().format('DD/MM/YYYY'),
            toDate: moment().format('DD/MM/YYYY'),
            breakDate: moment().format('DD/MM/YYYY'),
            valueSelectEmployee: [],
            selectedOldYear: false,
            statusOverview: "0",
            oldYearOverview: _currentYear,
            paramExportErStatus: {
                dateFrom: moment().format('DD/MM/YYYY'),
                dateTo: moment().format('DD/MM/YYYY'),
                departmentId: "",
                employeeId: [],
            }
        }
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps) {  
        this.setState({
            file: nextProps.importFile
        });
    }

    // Close popup
    handleClose = (evt) => {
        this.props.handleClose();
    }

    // Clear input employee
    handleClearEmployee = () => {
        this.setState({
            valueSelectEmployee: []
        })
    }

    onChangeEmployee = (name, value) => {
        if (this.state.hasOwnProperty(name)) {
            this.setState({
                [name]: value
            });
        }

        if (this.props.isStaffSupervisor) {
            this.setState(prevState => ({
                exportDisabled: (prevState.employeeId !== '') ? false : true,
                importButton: (prevState.file !== undefined && prevState.employeeId !== '' && prevState.supervisorId !== '' && prevState.approverId !== '') ? false : true
            }));
        } else {
            this.setState(prevState => ({
                exportDisabled: (prevState.employeeId) ? false : true,
                importButton: (prevState.file !== undefined && prevState.employeeId !== '' && prevState.approverId !== '') ? false : true
            }));
        } 
    }

    onChangeProject = (name, value) => {
        if (this.state.hasOwnProperty(name)) {
            this.setState({
                [name]: value
            });
        }

        if (this.props.isStaffSupervisor) {
            this.setState(prevState => ({
                exportDisabled: (prevState.projectId !== '') ? false : true,
                importButton: (prevState.file !== undefined && prevState.projectId !== '' && prevState.supervisorId !== '' && prevState.approverId !== '') ? false : true
            }));
        } else {
            this.setState(prevState => ({
                exportDisabled: (prevState.projectId !== '') ? false : true,
                importButton: (prevState.file !== undefined && prevState.projectId !== '' && prevState.approverId !== '') ? false : true
            }));
        } 
    }

    handleChangeDepartment = (name, value) => {
        this.setState(prevState => ({
            paramExportErStatus: {
                ...prevState.paramExportErStatus,
                [name]: value,
                employeeId: []
            }
        }));
        this.setState({
            valueSelectEmployee: []
        })
        this.props.changeSelectEmployeeModal({ _name: "employeeId", _value: [] })
        this.props.changeSelectDepartmentModal({ _name: "departmentId", _value: value });
    }

    handleChangeDepartmentExport = (event) => {
        this.handleChangeDepartment("departmentId", event)
    }

    handleChangeEmployee = (value) => {
        this.setState({
            valueSelectEmployee: value
        })
        this.props.changeSelectEmployeeModal({ _name: "employeeId", _value: value })
    }

    handleChangeEmployeeErStatus = (value) => {
        this.setState(prevState => ({
            paramExportErStatus: {
                ...prevState.paramExportErStatus,
                employeeId: value
            }
        }));
    }

    handleExportAll = () => {
        this.props.buttonExport()
    }

    handleExportErStatus = () => {
        const _dateFrom = this.state.paramExportErStatus.dateFrom;
        const _dateTo = this.state.paramExportErStatus.dateTo;
        const dateFrom = new Date(moment(_dateFrom, "DDMMYYYY ").local())
        const dateTo = new Date(moment(_dateTo, "DDMMYYYY ").local())
        if (dateTo < dateFrom) {
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    importError: "message.040"
                }
            }));
        }
        else {
            this.props.buttonExportErStatus(this.state.paramExportErStatus)
        }
    }

    handleChangeYear = (e) => {
        this.setState({
            selectedOldYear: e.target.value === "oldYear",
            oldYearOverview: this.state.currentYear
        });
    };

    handleChangeEmployeeStatus = (e) => {
        this.setState({
            statusOverview: e.target.value,
        });
    };
 
    handleChangeOldYear = (e) => {
        this.setState({
            oldYearOverview: e.target.value,
        });
    };

    handleExport = () => {
        this.props.handleExportOverview({
            status: this.state.statusOverview,
            year: this.state.selectedOldYear ? this.state.oldYearOverview : "",
        });
    };

    // Render ER form
    erForm = () => {
        const { t, modalStyle, employeeData, supervisorData, approverData } = this.props;
        const { monthArr, currentYear, currentMonth, yearArr, file } = this.state;
        const { Option } = Select;
        const _employeeData = _.map(employeeData, (state, index) => ({
            key: "employee-" + index + 1,
            text: state['employeeCode'] + " - " + state['employeeName'],
            value: state['id'],
        }));
        const _supervisorData = _.map(supervisorData, (state, index) => ({
            key: "employee-" + index + 1,
            text: state['employeeCode'] + " - " + state['employeeName'],
            value: state['id'],
        }));
        const _approverData = _.map(approverData, (state, index) => ({
            key: "employee-" + index + 1,
            text: state['employeeCode'] + " - " + state['employeeName'],
            value: state['id'],
        }));
        let fileName = file ? file.name : t('labels.fileText');

        if (modalStyle !== 'erForm') return
        return (
            <div className="er-form er-import-form">
                <div className="list-actions">
                    <Button
                        disabled={this.state.exportDisabled}
                        onClick={e => this.erExportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.exportStandardFile")}
                    </Button>
                    <Button
                        disabled={this.state.importButton}
                        onClick={e => this.erImportAction()}
                    >
                        <Icon name="file excel outline" />
                        {this.state.importing ? t("button.importing") : t("button.import")}
                    </Button>
                </div>
                <Form>
                    <Form.Group inline>
                        <label>{t("labels.employee")}</label>
                        <Select
                            name="employeeId"
                            onChange={(input, option) => this.onChangeEmployee("employeeId", option.props.value)}
                            style={{ width: 200 }}
                            showSearch
                            filterOption={functionCommon.filterEmployee}
                            value={this.state.employeeId}
                        >
                            {_employeeData.map((item, index) =>
                                <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                            )}
                        </Select>
                    </Form.Group>
                    {(this.props.isStaffSupervisor)
                    ?<Form.Group inline>
                        <label>{t("labels.supervisor")}</label>
                        <Select
                            name="supervisorId"
                            onChange={(input, option) => this.onChangeEmployee("supervisorId", option.props.value)}
                            style={{ width: 200 }}
                            showSearch
                            filterOption={(input, option) =>
                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={this.state.supervisorId}
                        >
                            {_supervisorData.map((item, index) =>
                                <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                            )}
                        </Select>
                    </Form.Group>
                    : ''}
                    <Form.Group inline>
                        <label>{t("labels.approver")}</label>
                        <Select
                            name="approverId"
                            onChange={(input, option) => this.onChangeEmployee("approverId", option.props.value)}
                            style={{ width: 200 }}
                            showSearch
                            filterOption={(input, option) =>
                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={this.state.approverId}
                        >
                            {_approverData.map((item, index) =>
                                <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                            )}
                        </Select>
                    </Form.Group>
                    <Form.Group inline>
                        <label>{t("labels.year")}</label>
                        <select name="year" className="small-select year-select"
                            value={currentYear}
                            onChange={e => { this.handleChangeSelect(e) }}
                        >
                            {yearArr.map((option, index) => {
                                return (
                                    <option value={option} key={index}>{option}</option>
                                )
                            })
                            }
                        </select>
                        <label className="modal-label-month">{t("labels.month")}</label>
                        <select name="month" className="small-select month-select"
                            value={currentMonth}
                            onChange={e => { this.handleChangeSelect(e) }}
                        >
                            {monthArr.map((option, index) => {
                                return (
                                    <option value={option.value} key={index}>{option.name}</option>
                                )
                            })
                            }
                        </select>
                    </Form.Group>
                    <Form.Group inline>
                        <label>{t("labels.importFile")}</label>
                        <div className="upload-group">
                            <Button
                                className="btn-upload"
                                content={fileName}
                                labelPosition="right"
                                icon="h"
                                type="button"
                                size="small"
                                onClick={() => this.fileInputRef.current.click()}
                            />
                            <input
                                ref={this.fileInputRef}
                                type="file"
                                hidden
                                onChange={(e) => this.onFileChange(e)}
                                accept=".xlsx, .xls, .xlsm"
                                key={this.state.file}
                            />
                        </div>
                    </Form.Group>
                    {
                        (this.state.inputSubmit.importError)
                            ? <div className="error-message form-list-message">{t(this.state.inputSubmit.importError)}</div>
                            : ''
                    }
                </Form>
            </div>
        )
    }

    // Render ER Om form
    erOmForm = () => {
        const { t,  modalStyle, projectData, supervisorData, approverData } = this.props;
        const { monthArr, currentYear, currentMonth, yearArr, file } = this.state;
        const { Option } = Select;
        const _projectData = _.map(projectData, (state, index) => ({
            key: "project-" + index + 1,
            text: state['projectCode'] + " - " + state['projectName'],
            value: state['id'],
        }));
        const _supervisorData = _.map(supervisorData, (state, index) => ({
            key: "employee-" + index + 1,
            text: state['employeeCode'] + " - " + state['employeeName'],
            value: state['id'],
        }));
        const _approverData = _.map(approverData, (state, index) => ({
            key: "employee-" + index + 1,
            text: state['employeeCode'] + " - " + state['employeeName'],
            value: state['id'],
        }));
        let fileName = file ? file.name : t('labels.fileText'); 
        if (modalStyle !== 'erOmForm') return
        return (
            <div className="er-om-form er-import-form">
                <div className="list-actions">
                    <Button
                        disabled={this.state.exportDisabled}
                        onClick={e => this.erOmExportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.exportStandardFile")}
                    </Button>
                    <Button
                        disabled={this.state.importButton}
                        onClick={e => this.erOmImportAction()}
                    >
                        <Icon name="file excel outline" />
                        {this.state.importing ? t("button.importing") : t("button.import")}
                    </Button>
                </div>
                <Form>
                    <Form.Group inline>
                        <label>{t("labels.project")}</label>
                        <Select
                            name="projectId"
                            onChange={(input, option) => this.onChangeProject("projectId", option.props.value)}
                            style={{ width: 200 }}
                            showSearch
                            filterOption={(input, option) =>
                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={this.state.projectId}
                        >
                            {_projectData.map((item, index) =>
                                <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                            )}
                        </Select>
                    </Form.Group>
                    {(this.props.isStaffSupervisor)
                    ?<Form.Group inline>
                        <label>{t("labels.supervisor")}</label>
                        <Select
                            name="supervisorId"
                            onChange={(input, option) => this.onChangeProject("supervisorId", option.props.value)}
                            style={{ width: 200 }}
                            showSearch
                            filterOption={(input, option) =>
                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={this.state.supervisorId}
                        >
                            {_supervisorData.map((item, index) =>
                                <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                            )}
                        </Select>
                    </Form.Group>
                    : ''}
                    <Form.Group inline>
                        <label>{t("labels.approver")}</label>
                        <Select
                            name="approverId"
                            onChange={(input, option) => this.onChangeProject("approverId", option.props.value)}
                            style={{ width: 200 }}
                            showSearch
                            filterOption={(input, option) =>
                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={this.state.approverId}
                        >
                            {_approverData.map((item, index) =>
                                <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                            )}
                        </Select>
                    </Form.Group>
                    <Form.Group inline>
                        <label>{t("labels.year")}</label>
                        <select name="year" className="small-select year-select"
                            value={currentYear}
                            onChange={e => { this.handleChangeSelect(e) }}
                        >
                            {yearArr.map((option, index) => {
                                return (
                                    <option value={option} key={index}>{option}</option>
                                )
                            })
                            }
                        </select>
                        <label className="modal-label-month">{t("labels.month")}</label>
                        <select name="month" className="small-select month-select"
                            value={currentMonth}
                            onChange={e => { this.handleChangeSelect(e) }}
                        >
                            {monthArr.map((option, index) => {
                                return (
                                    <option value={option.value} key={index}>{option.name}</option>
                                )
                            })}
                        </select>
                    </Form.Group>
                    <Form.Group inline>
                        <label>{t("labels.importFile")}</label>
                        <div className="upload-group">
                            <Button
                                className="btn-upload"
                                content={fileName}
                                labelPosition="right"
                                icon="h"
                                type="button"
                                size="small"
                                onClick={() => this.fileInputRef.current.click()}
                            />
                            <input
                                ref={this.fileInputRef}
                                type="file"
                                hidden
                                onChange={(e) => this.onFileChange(e)}
                                accept=".xlsx, .xls, .xlsm"
                                key={this.state.file}
                            />
                        </div>
                    </Form.Group>
                    {
                        (this.state.inputSubmit.importError)
                            ? <div className="error-message form-list-message">{t(this.state.inputSubmit.importError)}</div>
                            : ''
                    }
                </Form>
            </div>
        )
    }

    // Render OT/Leave Form
    otLeaveForm = () => {
        const { t,  modalStyle, onPage } = this.props;
        if (modalStyle !== 'otLeaveForm') return
        return (
            <div className="er-om-form er-import-form">
                <div className="list-actions">
                    <Button primary onClick={e => (onPage !== undefined && onPage === 'inquiryData') ? this.otReportActionInquiry() : this.otReportAction()}>
                        <Icon name="file excel outline" />
                        {t("button.otReport")}
                    </Button>
                    <Button primary onClick={e => (onPage !== undefined && onPage === 'inquiryData') ? this.leaveReportActionInquiry() : this.leaveReportAction()}>
                        <Icon name="file excel outline" />
                        {t("button.leaveReport")}
                    </Button>
                </div>
                <Form>
                    <Form.Group inline className="form-required">
                        <label>{t("labels.fromDate")}</label>
                        <DateInput
                            name="fromDate"
                            iconPosition="right"
                            animation="none"
                            dateFormat="DD/MM/YYYY"
                            value={this.state.fromDate}
                            onChange={this.changeDate}
                            closeOnMouseLeave={false}
                            localization={localStorage.getItem('i18nextLng') === 'en' ? 'en' : 'vi'}
                            hideMobileKeyboard={true}
                            autoComplete="off"
                            maxLength="0"
                            closable={true}
                            onKeyDown={this.handleKeyDown}
                            className="export-date-input"
                        />
                    </Form.Group>
                    <Form.Group inline className="form-required">
                        <label>{t("labels.toDate")}</label>
                        <DateInput
                            name="toDate"
                            iconPosition="right"
                            animation="none"
                            dateFormat="DD/MM/YYYY"
                            value={this.state.toDate}
                            onChange={this.changeDate}
                            closeOnMouseLeave={false}
                            localization={localStorage.getItem('i18nextLng') === 'en' ? 'en' : 'vi'}
                            hideMobileKeyboard={true}
                            autoComplete="off"
                            maxLength="0"
                            closable={true}
                            onKeyDown={this.handleKeyDown}
                            className="export-date-input"
                        />
                    </Form.Group>
                    <Form.Group inline className="form-required">
                        <label>{t("labels.breakDate")}</label>
                        <DateInput
                            name="breakDate"
                            iconPosition="right"
                            animation="none"
                            dateFormat="DD/MM/YYYY"
                            value={this.state.breakDate}
                            onChange={this.changeDate}
                            closeOnMouseLeave={false}
                            localization={localStorage.getItem('i18nextLng') === 'en' ? 'en' : 'vi'}
                            hideMobileKeyboard={true}
                            autoComplete="off"
                            maxLength="0"
                            closable={true}
                            onKeyDown={this.handleKeyDown}
                            className="export-date-input"
                        />
                    </Form.Group>
                </Form>
            </div>
        )
    }

    // Render Export All Employee Form 
    exportER = () => {
        const { t, modalStyle, dataDepartmentSlectBox, dataEmployeeSlectBox } = this.props;
        const { Option } = Select;
        const _employeeList = _.map(dataEmployeeSlectBox, (item, index) => ({
            key: 'employee' + index + 1,
            text: item['employeeCode'] + ' - ' + item['employeeName'],
            value: item['employeeId']
        }))
        const _dataDepartmentSlectBox = _.map(dataDepartmentSlectBox, (item, index) => ({
            key: 'department' + index + 1,
            text: item['departmentName'],
            value: item['departmentId'],
        }))
        _dataDepartmentSlectBox.unshift({
            key: 'department-0',
            text: 'All',
            value: ' '
        })
        if (modalStyle !== 'exportER') return
            return (
                <div className="er-export-form er-export-all" >
                    <div className="list-actions">
                        <Button onClick={this.handleExportAll} >
                            {t("button.export")}
                        </Button>
                    </div>
                    <Form className="form-export">
                        <Form.Group inline className='wrapper-txtbox-modal wrapper-txtbox-modal--top'>
                        <label>{t("labels.department")}</label>
                            <Select className="department-select"  name="departmentId" 
                                showSearch 
                                filterOption={(input, option) =>
                                    option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                defaultValue={' '}
                                onChange={this.handleChangeDepartmentExport}>
                                {
                                    (_dataDepartmentSlectBox)
                                        ? _dataDepartmentSlectBox.map((item, index) => {
                                            return (
                                                <Option value={item.value} label={item.text} key={item.key}>{item.text}</Option>
                                            )
                                        }) : ''}
                            </Select>
                        </Form.Group>
                        <Form.Group inline className='wrapper-txtbox-modal'>
                        <label>{t("labels.employee")}</label>
                            <Select 
                                className="employee-select" 
                                mode="multiple" 
                                name="employeeId"
                                showSearch
                                showArrow
                                allowClear
                                maxTagCount={2}
                                placeholder={"All"}
                                filterOption={functionCommon.filterEmployee}
                                value={this.state.valueSelectEmployee}
                                onChange={this.handleChangeEmployee}>
                                {
                                    (_employeeList)
                                        ? _employeeList.map((item, index) => {
                                            return (
                                                <Option value={item.value} label={item.text} key={item.key}>{item.text}</Option>
                                            )
                                        }) : ''}
                            </Select>
                        </Form.Group>
                    </Form>
                </div >
            )
    }

    // Render Export Leave Overview
    exportOverview = () => {
        const { t, modalStyle } = this.props;
        const { oldYearOverview, yearArr } = this.state;
        if (modalStyle !== "overViewModal") return;
        return (
            <div className="er-export-form overview-modal">
                <div className="form-radio">
                    <div className="employee-status-radio">
                        <div className="working radio">
                            <input
                                id="radio-working"
                                type="radio"
                                name="employeeStatus"
                                defaultChecked
                                value="0"
                                onChange={this.handleChangeEmployeeStatus}
                            />
                            <label htmlFor="radio-working">{t("labels.working")}</label>
                        </div>
                        <div className="non-working radio">
                            <input
                                id="radio-non-working"
                                type="radio"
                                name="employeeStatus"
                                value="1"
                                onChange={this.handleChangeEmployeeStatus}
                            />
                            <label htmlFor="radio-non-working">{t("labels.nonWorking")}</label>
                        </div>
                        <div className="all-employee radio">
                            <input
                                id="radio-all-employee"
                                type="radio"
                                name="employeeStatus"
                                value=""
                                onChange={this.handleChangeEmployeeStatus}
                            />
                            <label htmlFor="radio-all-employee">{t("labels.allEmployee")}</label>
                        </div>
                    </div>
                    <div className="year-radio">
                        <div className="current-year radio">
                            <input
                                id="radio-current-year"
                                type="radio"
                                name="year"
                                defaultChecked
                                onChange={this.handleChangeYear}
                                value="currentYear"
                            />
                            <label htmlFor="radio-current-year">{t("labels.currentYear")}</label>
                        </div>
                        <div className="old-year radio">
                            <input
                                id="radio-old-year"
                                type="radio"
                                name="year"
                                onChange={this.handleChangeYear}
                                value="oldYear"
                            />
                            <label htmlFor="radio-old-year">{t("labels.oldYear")}</label>
                        </div>
                        <div className="year radio">
                            {this.state.selectedOldYear && (
                                <select
                                    name="year"
                                    className="small-select year-select"
                                    value={oldYearOverview}
                                    onChange={this.handleChangeOldYear}
                                >
                                    {yearArr.map((option, index) => {
                                        return (
                                            <option value={option} key={index}>
                                                {option}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                        </div>
                    </div>
                </div>
                <Button className="leave-button" onClick={this.handleExport}>
                    {t("button.export")}
                </Button>
            </div>
        );
    };

    // Render Error Modal    
    errorModal = () => {
        const {modalStyle, textContent} = this.props
        if (modalStyle !== 'errorModal') return
        return (
            <div className="er-export-form modal-error">
                <div>
                    <p>{textContent}</p>
                </div>
                <div className="list-actions">
                    <Button onClick={this.handleClose} >
                    Ok
                    </Button>
                </div>
            </div>
        )
    }

    // Render Status Modal
    statusModal = () => {
        const { t, modalStyle, dataDepartmentSlectBox, dataEmployeeSlectBox } = this.props;
        const _employeeList = _.map(dataEmployeeSlectBox, (item, index) => ({
            key: 'employee' + index + 1,
            text: item['employeeCode'] + ' - ' + item['employeeName'],
            value: item['employeeId']
        }))
        const _dataDepartmentSlectBox = _.map(dataDepartmentSlectBox, (item, index) => ({
            key: 'department' + index + 1,
            text: item['departmentName'],
            value: item['departmentId'],
        }))
        _dataDepartmentSlectBox.unshift({
            key: 'department-0',
            text: 'All',
            value: ' '
        })
        if (modalStyle !== 'statusERModal') return
            return (
                <div className="er-export-form er-export-status" >
                    <div className="list-actions">
                        <Button onClick={this.handleExportErStatus} >
                            {t("button.export")}
                        </Button>
                    </div>
                    <Form className="form-export">
                        <Form.Group inline className="wrapper-txtbox-modal wrapper-txtbox-modal--top">
                            <label className="text-date-from">{t("labels.from")}</label>
                            <DateInput
                                className="date date-from leave-date-input-restrict"
                                name="dateFrom"
                                placeholder="DD-MM-YYYY"
                                iconPosition="right"
                                animation="none"
                                dateFormat="DD/MM/YYYY"
                                onChange={this.changeDate}
                                value={this.state.paramExportErStatus.dateFrom}
                                closeOnMouseLeave={false}
                                localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                                hideMobileKeyboard={true}
                                autoComplete="off"
                                maxLength="0"
                                closable={true}
                                onKeyDown={functionCommon.onKeyDownDateInput}
                                onMouseEnter={functionCommon.onMouseEnterDateInput}
                                onMouseLeave={functionCommon.onMouseLeaveDateInput}
                            />
                            <label className="text-date-to">{t("labels.to")}</label>
                            <DateInput
                                className="date date-to leave-date-input-restrict"
                                name="dateTo"
                                placeholder="DD/MM/YYYY"
                                iconPosition="right"
                                animation="none"
                                dateFormat="DD/MM/YYYY"
                                onChange={this.changeDate}
                                value={this.state.paramExportErStatus.dateTo}
                                closeOnMouseLeave={false}
                                localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                                hideMobileKeyboard={true}
                                autoComplete="off"
                                maxLength="0"
                                closable={true}
                                onKeyDown={functionCommon.onKeyDownDateInput}
                                onMouseEnter={functionCommon.onMouseEnterDateInput}
                                onMouseLeave={functionCommon.onMouseLeaveDateInput}
                            />
                        </Form.Group>
                        <div className='wrapper-txtbox-error'>
                        {
                            (this.state.inputSubmit.importError)
                            ? <div className="error-message message">{t(this.state.inputSubmit.importError)}</div>
                            : ''
                        }
                        </div>
                        <Form.Group inline className='wrapper-txtbox-modal wrapper-txtbox-modal--top'>
                            <label>{t("labels.department")}</label>
                            <Select className="department-select"  name="departmentId" 
                                showSearch 
                                filterOption={(input, option) =>
                                    option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                defaultValue={' '}
                                onChange={this.handleChangeDepartmentExport}
                            >
                                {_dataDepartmentSlectBox && 
                                    _dataDepartmentSlectBox.map((item, index) => {
                                        return (
                                            <option value={item.value} label={item.text} key={item.key}>{item.text}</option>
                                        );
                                    })
                                }
                            </Select>
                        </Form.Group>
                        <Form.Group inline className='wrapper-txtbox-modal'>
                        <label>{t("labels.employee")}</label>
                            <Select className="employee-select" mode="multiple" name="employeeId"
                                showSearch
                                showArrow
                                allowClear
                                maxTagCount={2}
                                filterOption={functionCommon.filterEmployee}
                                value={this.state.paramExportErStatus.employeeId}
                                onChange={this.handleChangeEmployeeErStatus}
                            >
                                {_employeeList && 
                                    _employeeList.map((item, index) => {
                                        return (
                                            <option value={item.value} label={item.text} key={item.key}>{item.text}</option>
                                        );
                                    })
                                    }
                            </Select>
                        </Form.Group>
                    </Form>
                </div >
            )
    }

    // Render Title popup
    renderTitle = () => {
        const { t,  modalStyle, title } = this.props;
        if (modalStyle === 'erForm') {
            return  (<p>ER / {t("button.import")} ER</p>)
        } else if (modalStyle === 'erOmForm') {
            return  (<p>ER / {t("button.import")} ER - OM</p>)
        } else if (modalStyle === 'otLeaveForm') {
            return  (<p>{t("labels.otLeaveReport")}</p>)
        } else if (modalStyle === 'exportER') {
            return  (<p>{t("button.export")} ER</p>)
        } else if (modalStyle === 'overViewModal') {
            return  (<p>{t("labels.exportLeaveOverview")}</p>)
        } else if (modalStyle === 'errorModal') {
            return  (<p>{t("labels.validatError")}</p>)
        } else if (modalStyle === 'statusERModal') {
            return  (<p>{t("button.exportERStatus")}</p>)
        }
        
    }

    changeDate = (event, { name, value }) => {
        this.clearError()
        this.setState(prevState => ({
            paramExportErStatus: {
                ...prevState.paramExportErStatus,
                [name]: value
            }
        }));
        if (this.state.hasOwnProperty(name)) {
            this.setState({ [name]: value });
        }
    }

    handleKeyDown = (event) => {
        if (event.keyCode === 8 || event.keyCode === 46) {
            event.preventDefault();
        }
    }

    // Change select selectbox
    handleChangeSelect = (evt) => {
        const name = evt.target.name;
        const value = evt.target.value;   
        switch (name) {
            case 'year':
                this.setState({
                    currentYear: value
                });
                break;
            case 'month':
                this.setState({
                    currentMonth: value
                });
                break;
        }
    }

    // Import file
    fileInputRef = React.createRef();
    onFileChange = (value) => {
        const file = value.target.files[0]
        if (!file) return
        if ((file.size / 1024 / 1024 < 2) && functionCommon.checkfile(file) == true) {
            if (value.target.files[0]) {
                if (this.props.isStaffSupervisor) {
                    this.setState({
                        file: value.target.files[0],
                        importButton: (!this.state.exportDisabled && this.state.supervisorId !== '' && this.state.approverId !== '') ? false : true
                    });
                } else {
                    this.setState({
                        file: value.target.files[0],
                        importButton: (!this.state.exportDisabled && this.state.approverId !== '') ? false : true
                    });
                }
            } else {
                this.setState({
                    importButton: true
                });
            }
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    importError: ""
                }
            }));
        } else {
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    importError: "message.010"
                }
            }));
            
            this.setState({
                file: '',
                importButton: true
            });
        }
    }

    // Clear input error text
    clearError = () => {
        this.setState({
            inputSubmit: {
                isSubmit: false,
                formError: {},
                importError:""
            },
        });
    }

    // Action 
    erExportAction = () => {
        const exportParam = {
            month: this.state.currentMonth,
            year: this.state.currentYear,
            employeeId: this.state.employeeId
        };
        commonService.exportFile('workLog/downloadImportStandardFile', exportParam);
    }
    
    otReportAction = () => {
        const exportParam = {
            fromDate: moment(this.state.fromDate, 'DDMMYYYY').format('YYYY-MM-DD'),
            toDate: moment(this.state.toDate, 'DDMMYYYY').format('YYYY-MM-DD'),
            breakDate: moment(this.state.breakDate, 'DDMMYYYY').format('YYYY-MM-DD')
        };
        this.props.exportFileAction({
            'urlGetkey': 'OMProject/requestSecretKey',
            'urlDownfile':  'EngineerHourRecord/oTExport'
        }, exportParam);
    }
    
    leaveReportAction = () => {
        const exportParam = {
            fromDate: moment(this.state.fromDate, 'DDMMYYYY').format('YYYY-MM-DD'),
            toDate: moment(this.state.toDate, 'DDMMYYYY').format('YYYY-MM-DD')
        };
        this.props.exportFileAction({
            'urlGetkey': 'OMProject/requestSecretKey',
            'urlDownfile':  'EngineerHourRecord/leaveExport'
        }, exportParam);
    }
    
    // OT Report Inquiry Data
    otReportActionInquiry = () => {
        const exportParam = {
            fromDate: moment(this.state.fromDate, 'DDMMYYYY').format('YYYY-MM-DD'),
            toDate: moment(this.state.toDate, 'DDMMYYYY').format('YYYY-MM-DD'),
            breakDate: moment(this.state.breakDate, 'DDMMYYYY').format('YYYY-MM-DD'),
            employeeID: this.props.employeeId
        };
        this.props.exportFileAction({
            'urlGetkey': 'OMProject/requestSecretKey',
            'urlDownfile':  'WorkLog/oTExport'
        }, exportParam);
    }
    
    // Leave Report Inquiry Data
    leaveReportActionInquiry = () => {
        const exportParam = {
            fromDate: moment(this.state.fromDate, 'DDMMYYYY').format('YYYY-MM-DD'),
            toDate: moment(this.state.toDate, 'DDMMYYYY').format('YYYY-MM-DD'),
            breakDate: moment(this.state.breakDate, 'DDMMYYYY').format('YYYY-MM-DD'),
            employeeID: this.props.employeeId
        };
        this.props.exportFileAction({
            'urlGetkey': 'OMProject/requestSecretKey',
            'urlDownfile':  'WorkLog/leaveExport'
        }, exportParam);
    }

    erImportAction = () => {
        this.setState({
            importButton: true,
            importing: true
        });
        const fileName = this.state.file ? this.state.file : null;
        this.fileErUpload(fileName);
    }

    fileErUpload = file => {
        const currentUrl  = window.location.href;
        const fileUpload = file;
        const currentMonth = this.state.currentMonth;
        const currentYear = this.state.currentYear;
        const supervisorId = this.state.supervisorId;
        const approverId = this.state.approverId;
        this.props.importErOmFileAction(
            {
                urlGetkey: "workLog/requestSecretKey",
                urlDownfile: "workLog/importEr"
            },
            fileUpload,
            currentMonth,
            currentYear,
            supervisorId,
            approverId,
            currentUrl
        );
    };
    
    erOmExportAction = () => {
        const exportParam = {
            month: this.state.currentMonth,
            year: this.state.currentYear,
            projectId: this.state.projectId,
            employeeId: ''
        };
        commonService.exportFile('workLog/downloadImportOMStandardFile', exportParam);
    }

    erOmImportAction = () => {
        this.setState({
            importButton: true,
            importing: true
        });
        const fileName = this.state.file ? this.state.file : null;
        this.fileErOmUpload(fileName);
    }

    fileErOmUpload = file => {
        const currentUrl  = window.location.href;
        const fileUpload = file;
        const currentMonth = this.state.currentMonth;
        const currentYear = this.state.currentYear;
        const supervisorId = this.state.supervisorId;
        const approverId = this.state.approverId;
        this.props.importErOmFileAction(
            {
                urlGetkey: "workLog/requestSecretKey",
                urlDownfile: "workLog/importErOm"
            },
            fileUpload,            
            currentMonth,
            currentYear,
            supervisorId,
            approverId,
            currentUrl
        );
    };

    render() {
        const { t, size, open, modalStyle } = this.props;
        return (
            <div>
                <Modal size={size} open={open} onClose={this.handleClose} className={modalStyle === "errorModal" && "error-modal-width"}>
                    <Modal.Header className="modal-header">
                        {this.renderTitle()}
                        <p className="modal-close" onClick={() => this.handleClose()}>x</p>
                    </Modal.Header>
                    <Modal.Content>
                        {this.erForm()}
                        {this.erOmForm()}
                        {this.otLeaveForm()}
                        {this.exportER()}
                        {this.exportOverview()}
                        {this.errorModal()}
                        {this.statusModal()}
                    </Modal.Content>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    importFileAction: (url, param) => dispatch(importFileAction(url, param)),
    importErOmFileAction: (url, param, _month, _year, _supervisorId, _approverId, _currentUrl) => dispatch(importErOmFileAction(url, param, _month, _year, _supervisorId, _approverId, _currentUrl)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param))
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(ERModal);
